import React  from 'react';
import { AbsoluteFill, Audio } from 'remotion';
import { Layer, ProjectState } from "../../shared";

type Props = { 
    layer: Layer,
    project: ProjectState
};

function AudioLayer({ layer }: Props) {
    const { 
        url, 
        startFrame,
        endFrame 
    } = layer;

    if (!url) return null;

    return (
        <>
            <AbsoluteFill>
                <Audio
                    startFrom={startFrame}
                    endAt={endFrame}
                    src={url}
                />
            </AbsoluteFill>
        </>
    )
}


export default AudioLayer;
